import React, {useState} from 'react';
import {Search, MediaContents} from 'components/items';

const MediaWithSearch = (props) => {

  const [search, setSearch] = useState('');
  const [sel, setSel] = useState('title');

  const onSearchClick = (e) => {
    e.preventDefault();
    const newMedias = props.data.filter(el=> {
      if(sel === 'title'){
        return el.title.toLowerCase().includes(search.toLowerCase())
      }else{
        return el.text.toLowerCase().includes(search.toLowerCase())
      }
    })
    props.setResultData(newMedias);
  }

  const onSearchChange = (e) => {    
    setSearch(e.target.value);
  }
  const handleSelectChange = (e) => {
    setSel(e.target.value)
  }

  return (
    <section className="MediaWithSearch">
      <Search onChange = {onSearchChange} handleSelectChange = {handleSelectChange} search = {search} onClick = {onSearchClick}/>
      <MediaContents items = {props.currentPosts}/>
    </section>
  );
}

export default MediaWithSearch;